import global_axios from '../../funciones_globales/interaccionapi';
import { 	CARGAR_PTOSFACTURACION, SELECCIONAR_PTOFACTURACION, 
			CARGAR_PROFORMAS, SET_DOCSPORIMPRIMIR, UPDATE_ESTADO_IMPRESION_DOCIMPRIMIR,
			CARGAR_FACTURA, CARGAR_PAGOS_FACTURA, INICIALIZAR_FACTURA } from './actionTypes';
import { VISUALIZAR_ALERTA, VISUALIZAR_LOADING } from '../generales/actionTypes';
import { completar_String } from '../../funciones_globales/format';

export const cargar_PuntosFacturacion = (empresaId, usuario, accesoPtoFact='T') => {	
	return (dispatch) => {
		return global_axios({
			url: `/puntosfacturacion?codempresa=${empresaId}&usuario=${usuario}&accesoptofact=${accesoPtoFact}`,
			method: 'GET'
		})
		.then( response => {
			let ptosFacturacion = response.data;
			dispatch({
				type: CARGAR_PTOSFACTURACION,
				data: ptosFacturacion
			})
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar puntos de facturación', mensaje: msgError}
			});
		});
	}	
}

export const seleccionar_PuntoFacturacion = (idPtoFacturacion) => {
	return { type: SELECCIONAR_PTOFACTURACION,
			idPtoFacturacion
	};
}

export const cargar_Proformas = (operacion, cod_estado='', cliente='', pedidoMovil='') => {
	let url = '/proformas?operacion=' + operacion;

	if (cod_estado!=='') {
		url += '&estado=' + cod_estado;
	}

	if (cliente!==''){
		url += '&cliente=' + cliente;
	}

	if (pedidoMovil!==''){
		url += '&pedidomovil=' + pedidoMovil;
	}
	
	return (dispatch) => {
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios({
			url,
			method: 'GET'
		})		
		.then( response => {
			let proformas = response.data;
			proformas.forEach((proforma, i) => {
				proforma.Fecha = proforma.Fecha + ' ' + proforma.Hora;
				proforma.Nro = completar_String((i+1).toString(), '0', 3);
				proforma.Cliente = proforma.Cliente + ' - ' + proforma.NombreCliente;
				proforma.Vendedor = proforma.Vendedor + ' - ' + proforma.NombreVendedor;
			});
			dispatch({
				type: CARGAR_PROFORMAS,
				data: proformas
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar proformas', mensaje: msgError}
			});
		});
	}
}

export const setDocumentosPorImprimir = (docsPorImprimir)=>{
	return {type: SET_DOCSPORIMPRIMIR,	
			data: docsPorImprimir };
}

export const actualizarEstImpresionDcto = (doc)=>{
	return {type: UPDATE_ESTADO_IMPRESION_DOCIMPRIMIR,	
			data: doc };
}

export const cargar_Factura = (establecimiento, ptoEmision, numero) => {
	return (dispatch) => {
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios({
			url: '/facturas/' + establecimiento + "/" + ptoEmision + "/" + numero,
			method: 'GET'
		})
		.then( response => {
			let factura = response.data;
			dispatch({
				type: CARGAR_FACTURA,
				data: factura
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar factura', mensaje: msgError}
			});
		});
	}
}

export const cargar_PagosPorFactura = (idFactura, tipoConsulta) => {
	return (dispatch) => {
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios({
			url: `/facturas/${idFactura}/pagos?tipoConsulta=${tipoConsulta}`,
			method: 'GET'
		})
		.then( response => {
			let pagosFactura = response.data;
			dispatch({
				type: CARGAR_PAGOS_FACTURA,
				data: pagosFactura
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar pagos de factura', mensaje: msgError}
			});
		});
	}
}

export const inicializarFactura = () => {	
	return {
		type: INICIALIZAR_FACTURA,
		data: {}
	};
}